import { useState, useEffect } from "react";
import Link from "next/link";
import { Container, Row, Col } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { connect, useDispatch } from "react-redux";
import CustomPlan from "./CustomPlan";
import { setLoader } from "../../redux/actions/globalAction";
import Image from "next/image"
import { fetchLowestPackage } from "../../actions/homePage";
import IMAGES from '../../images'

const Offer = ({
  apiData,
  getModel,
  globalData,
  getCarBrandModal,
  setLoader,
}) => {
  const [showCustomPlan, setShowCustomPlan] = useState(false);
  const dispatch = useDispatch()

  useEffect(() => {
    if (globalData.locationData?.data) {
      dispatch(fetchLowestPackage(
        globalData.locationData?.data.EmirateId,
        globalData.locationData?.data.EmirateAreaId,
        globalData.carData?.brandId || null,
        globalData.carData?.modelId || null
      ))
    }
  }, [globalData.locationData?.data, globalData.carData]);

  return (
    <div
      className="offer"
      style={{
        marginTop: "3%",
        marginBottom: "3%",
        paddingLeft: isMobile ? "0px" : "30px",
        paddingRight: isMobile ? "0px" : "30px",
      }}
      onFocus={() => { }}
    >
      <Container fluid>
        <Row>
          <Col lg={7} md={7} sm={12} style={{ padding: "15px" }}>
            <div
              style={{
                background: "linear-gradient(#0451be, #5cbfff)",
                borderRadius: "15px",
                height: "100%",
                padding: "10px",
                display: "flex",
                flexDirection: "column",
                border: "5px solid #0451be",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  className="offer-head"
                  style={{
                    fontWeight: "700",
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  The OB Annual Service Contract
                </div>
              </div>
              <div
                className="service-contract-offer"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "20px",
                  height: "100%",
                }}
              >
                <ul
                  className="offer-text px-2"
                  style={{
                    fontWeight: "300",
                    color: "#fff",
                    width: "60%",
                    textAlign: "left",
                    lineHeight: "35px",
                    listStyle: "initial",
                  }}
                >
                  <li>One Country. One Price. Any Garage</li>
                  <li>Buy 6 months or annual service contracts </li>
                  <li>Get upto 70% lower price than dealerships </li>
                  <li>Fully online redemption & service tracking </li>
                </ul>
                <div
                  className="car-detail"
                  style={{
                    width: "40%",
                    // height: "100%",
                    background: "#F0F0F0",
                    borderRadius: "15px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "10px",
                  }}
                >
                  <div
                    className="offer-text"
                    style={{ textAlign: "center", color: "#000" }}
                  >
                    {globalData.carData?.brandId ? (
                      <span>
                        <span style={{ color: "#ff3201", fontWeight: "700" }}>
                          Service Contracts
                        </span>
                        <br />
                        For{" "}
                        <strong>
                          {globalData.carData?.brand}{" "}
                          {globalData.carData?.modal}
                        </strong>
                        <br />
                        Start at
                      </span>
                    ) : (
                      <span style={{ color: "#ff3201" }}>
                        Choose Car to View Price
                      </span>
                    )}
                  </div>
                  {globalData.carData?.brand && (
                    <div
                      className="offer-price"
                      style={{
                        fontSize: 24,
                        fontWeight: "700",
                        marginBottom: "10px",
                        color: "#000",
                      }}
                    >
                      {apiData?.lowestPackages?.MinCost &&
                        `AED ${apiData?.lowestPackages?.MinCost}`}
                    </div>
                  )}

                  {/* {car==null && modal==null ? <ChooseCar getCarBrandModal={getCarBrandModal} globalData={globalData} textTrue={false} style={"button-offer"} style1={{fontSize:isMobile ? 13 : 16,cursor:'pointer',width:'100%'}} apiData={apiData} getModel={getModel}/> */}
                  {!globalData.carData?.brand && (
                    <>

                      <button>
                        Choose your car
                      </button>
                    </>


                  )}
                  {globalData.carData?.brand && (
                    <Link
                      href={`/services/${globalData.locationData?.data?.EmirateAreaSlug ||
                        "dubai"
                        }/${apiData?.lowestPackages?.Slug}`}
                    >
                      <a className="w-100 mt-2" onClick={() => setLoader(true)}>
                        <div
                          className="button-offer mx-0"
                          style={{
                            fontSize: isMobile ? 13 : 16,
                            cursor: "pointer",
                          }}
                        >
                          Buy Now
                        </div>
                      </a>
                    </Link>
                  )}
                  <div
                    className="button-offer-one"
                    style={{ fontSize: isMobile ? 13 : 16, cursor: "pointer" }}
                    onClick={() => setShowCustomPlan(true)}
                  >
                    Request Custom Plan
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={5} md={5} sm={12} style={{ padding: "15px" }}>
            <div className="b3g1">
              <div className="text-center w-100">
                <h2 className="text-white">
                  Buy 3{" "}
                  <span className="one-line text-white">
                    Get
                    <span className="font-weight-bold text-yellow ml-2">
                      1 Free
                    </span>
                  </span>
                </h2>
                <p className="text-white m-0">
                  Every 4th Oil & Filter Change is{" "}
                  <span style={{ fontWeight: "600" }}>TOTALLY FREE !!</span>
                </p>
                <Container fluid>
                  <Row>
                    <Col xs={12} sm={7} className="p-0">
                      <div
                        style={{
                          // position: "absolute",
                          // left: 0,
                          width: "100%",
                          height: 200,
                          position: "relative",
                        }}
                        className="preview-img"
                      >
                        <Image
                          src={IMAGES.OIL_OFFER}
                          alt={"Oil Change Offer"}
                          layout="fill"
                          objectFit="contain"
                        />
                      </div>
                      {/* <img
                        src="/assets/oil-offer.webp"
                        className="preview-img"
                        width={"100%"}
                      /> */}
                    </Col>
                    <Col
                      xs={12}
                      sm={5}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <Link
                        href={`/services/${globalData.locationData?.data?.EmirateAreaSlug ||
                          "dubai"
                          }/oil-change-10k-oil-change-service-full-synthetic-5w40`}
                      >
                        <a onClick={() => setLoader(true)}>
                          <button className="button-offer">Book Now</button>
                        </a>
                      </Link>
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <CustomPlan
        show={showCustomPlan}
        handleClose={() => setShowCustomPlan(false)}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    profile: state.profile,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setLoader: (flag) => {
      dispatch(setLoader(flag));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Offer);
